import { FC, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

interface CardLayoutProps {
  head?: {
    title?: string;
    side?: ReactNode;
    noTitle?: boolean;
  };
  children: ReactNode;
  className?: string;
  isOpenProp?: boolean; // New optional prop to control open/close state
  onToggle?: (isOpen: boolean) => void; // Optional callback for external control
}

const CardLayout: FC<CardLayoutProps> = ({ head, children, className, isOpenProp, onToggle }) => {
  const { t } = useTranslation();
  const [isOpenInternal, setIsOpenInternal] = useState(true); // Internal state for open/close

  // Determine if the component is controlled externally
  const isControlled = isOpenProp !== undefined;

  // Use the `isOpenProp` if provided, otherwise use the internal state
  const isOpen = isControlled ? isOpenProp : isOpenInternal;

  const toggleAccordion = () => {
    if (isControlled) {
      // If controlled, call the `onToggle` callback with the new state
      onToggle?.(!isOpen);
    } else {
      // If uncontrolled, toggle the internal state
      setIsOpenInternal(!isOpenInternal);
    }
  };

  const isActionTitle = head?.title === "action" || head?.title === "previewForm";

  return (
    <div className={`rounded-lg bg-sidebar mb-3 ${className}`}>
      <div className="flex justify-between p-3 items-center cursor-pointer" onClick={!isActionTitle ? toggleAccordion : undefined}>
        <div className="flex flex-row items-center gap-2">
          <FontAwesomeIcon icon={faInfoCircle} className="text-primary" />
          <h4 className="text-lg font-semibold text-text">{head?.noTitle ? "" : head?.title ? t(head?.title) : t("basicInformation")}</h4>
        </div>
        <div className="flex items-center">
          {head?.side}
          {!isActionTitle && <FontAwesomeIcon icon={faChevronDown} className={`ml-2 text-text transition300 ${isOpen ? "rotate-180" : "rotate-0"}`} />}
        </div>
      </div>

      {(isOpen || isActionTitle) && <div className="p-4">{children}</div>}
    </div>
  );
};

export default CardLayout;
